package twist.mena.sports.admin.theme

import org.jetbrains.compose.web.css.*

fun StyleScope.themeTransition() {
    property("transition", "background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease")
}

fun StyleScope.cardStyle(colors: AppColors) {
    backgroundColor(Color(colors.surface))
    borderRadius(BorderRadius.lg)
    padding(Spacing.xxl)
    border(1.px, LineStyle.Solid, Color(colors.border))
    property("box-shadow", Shadow.sm)
    themeTransition()
}

fun StyleScope.primaryButtonStyle(colors: AppColors, disabled: Boolean = false) {
    padding(Spacing.md, Spacing.xl)
    backgroundColor(Color(if (disabled) colors.textMuted else colors.primary))
    color(Color("#ffffff"))
    border(0.px)
    borderRadius(BorderRadius.md)
    cursor(if (disabled) "not-allowed" else "pointer")
    fontSize(Typography.base)
    fontWeight("600")
    property("transition", "background-color 0.2s ease")
}

fun StyleScope.secondaryButtonStyle(colors: AppColors) {
    padding(Spacing.md, Spacing.xl)
    backgroundColor(Color(colors.surface))
    color(Color(colors.text))
    border(1.px, LineStyle.Solid, Color(colors.border))
    borderRadius(BorderRadius.md)
    cursor("pointer")
    fontSize(Typography.base)
    fontWeight("600")
    property("transition", "background-color 0.2s ease, border-color 0.2s ease")
}

fun StyleScope.dangerButtonStyle(colors: AppColors, disabled: Boolean = false) {
    padding(Spacing.md, Spacing.xl)
    backgroundColor(Color(if (disabled) colors.textMuted else colors.danger))
    color(Color("#ffffff"))
    border(0.px)
    borderRadius(BorderRadius.md)
    cursor(if (disabled) "not-allowed" else "pointer")
    fontSize(Typography.base)
    fontWeight("600")
    property("transition", "background-color 0.2s ease")
}

fun StyleScope.formInputStyle(colors: AppColors) {
    width(100.percent)
    padding(Spacing.md, Typography.base)
    fontSize(Typography.base)
    color(Color(colors.text))
    backgroundColor(Color(colors.surface))
    border(1.px, LineStyle.Solid, Color(colors.border))
    borderRadius(BorderRadius.md)
    property("outline", "none")
    themeTransition()
}

fun StyleScope.tableHeaderStyle(colors: AppColors) {
    padding(Spacing.md)
    textAlign("left")
    fontSize(Typography.sm)
    fontWeight("600")
    color(Color(colors.textMuted))
    property("text-transform", "uppercase")
    backgroundColor(Color(colors.surfaceHover))
    property("border-bottom", "1px solid ${colors.border}")
    themeTransition()
}

fun StyleScope.paginationButtonStyle(colors: AppColors, disabled: Boolean) {
    padding(Spacing.sm, Spacing.lg)
    backgroundColor(Color(if (disabled) colors.surfaceHover else colors.surface))
    color(Color(if (disabled) colors.textMuted else colors.text))
    border(1.px, LineStyle.Solid, Color(colors.border))
    borderRadius(BorderRadius.md)
    cursor(if (disabled) "not-allowed" else "pointer")
    fontSize(Typography.base)
    themeTransition()
}

fun StyleScope.badgeStyle(bgColor: String, textColor: String) {
    padding(Spacing.xs, Spacing.sm)
    backgroundColor(Color(bgColor))
    color(Color(textColor))
    borderRadius(BorderRadius.sm)
    fontSize(Typography.xs)
    fontWeight("600")
}

fun StyleScope.modalOverlayStyle(colors: AppColors) {
    position(Position.Fixed)
    top(0.px)
    left(0.px)
    right(0.px)
    bottom(0.px)
    backgroundColor(Color("rgba(0, 0, 0, 0.5)"))
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(AlignItems.Center)
    property("z-index", "1000")
}

fun StyleScope.modalContentStyle(colors: AppColors) {
    backgroundColor(Color(colors.surface))
    borderRadius(BorderRadius.lg)
    padding(Spacing.xxl)
    maxWidth(600.px)
    maxHeight(90.vh)
    property("overflow-y", "auto")
    width(90.vw)
    border(1.px, LineStyle.Solid, Color(colors.border))
    color(Color(colors.text))
    themeTransition()
}

fun StyleScope.confirmationOverlayStyle(colors: AppColors) {
    position(Position.Fixed)
    top(0.px)
    left(0.px)
    right(0.px)
    bottom(0.px)
    backgroundColor(Color("rgba(0, 0, 0, 0.7)"))
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(AlignItems.Center)
    property("z-index", "1001")
}

fun StyleScope.confirmationContentStyle(colors: AppColors) {
    backgroundColor(Color(colors.surface))
    borderRadius(BorderRadius.lg)
    padding(Spacing.xxl)
    maxWidth(400.px)
    border(1.px, LineStyle.Solid, Color(colors.border))
    color(Color(colors.text))
    themeTransition()
}

fun StyleScope.errorMessageStyle(colors: AppColors) {
    padding(Spacing.md)
    backgroundColor(Color(if (colors == LightColors) "#fee2e2" else "#450a0a"))
    color(Color(if (colors == LightColors) "#b91c1c" else "#fca5a5"))
    borderRadius(BorderRadius.md)
    marginBottom(Spacing.md)
    themeTransition()
}
